/**
 * @file cn.ts
 * @brief `cn` — utility for safely composing Tailwind class strings.
 *
 * @details
 * Wraps `clsx` (conditional joining) and `tailwind-merge` (conflict
 * resolution between competing utility classes). Used by every UI
 * primitive in `components/ui/*` and feature components.
 *
 * @dependencies
 * - clsx
 * - tailwind-merge
 *
 * @author DES
 * @date 26-05-2026
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
